import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            <span className="text-accent-600">CSSBuy Sheet</span> Resource Guides
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Comprehensive guides to help you master CSSBuy spreadsheet tools and shopping agent workflows
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5">
          <Link
            to="/cssbuy-sheet-guide"
            className="lg:col-span-3 lg:row-span-2 group relative rounded-2xl overflow-hidden h-64 lg:h-auto cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20workspace%20desk%20scene%20with%20laptop%20displaying%20spreadsheet%20data%2C%20surrounded%20by%20cream%20tone%20fashion%20accessories%20and%20sneakers%20softly%20arranged%2C%20diffused%20natural%20light%20from%20the%20side%2C%20clean%20aesthetic%20editorial%20photography%2C%20warm%20beige%20and%20cream%20color%20palette%20with%20subtle%20sage%20green%20accents&width=900&height=700&seq=article-featured-2026&orientation=portrait"
              alt="The Complete CSSBuy Spreadsheet Guide - learn how to use shopping agent spreadsheets effectively"
              title="CSSBuy Sheet Guide - Complete Shopping Agent Spreadsheet Tutorial"
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-400/90 text-background-50 text-xs font-semibold mb-3">
                Featured Guide
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2">
                The Complete CSSBuy Spreadsheet Guide 2026
              </h3>
              <p className="text-sm text-background-50/80 max-w-md">
                Everything you need to know about finding and using the best CSSBuy spreadsheets for shoes, clothing, and accessories.
              </p>
            </div>
          </Link>

          <Link
            to="/guides/shipping"
            className="lg:col-span-2 group relative rounded-2xl overflow-hidden h-44 cursor-pointer bg-gradient-to-br from-secondary-100 to-secondary-50"
          >
            <div className="absolute inset-0 flex items-center p-6">
              <div className="flex-1">
                <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-200/70 text-secondary-800 text-xs font-semibold mb-2">
                  Shipping Guide
                </span>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">
                  Shipping & Warehouse Tips
                </h3>
                <p className="text-xs text-foreground-600">
                  Learn how to ship your CSSBuy hauls efficiently
                </p>
              </div>
              <div className="w-14 h-14 rounded-xl bg-secondary-200 flex items-center justify-center flex-shrink-0 ml-4">
                <i className="ri-ship-line text-secondary-600 text-xl"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/guides/qc"
            className="lg:col-span-2 group relative rounded-2xl overflow-hidden h-44 cursor-pointer bg-gradient-to-br from-accent-100 to-accent-50"
          >
            <div className="absolute inset-0 flex items-center p-6">
              <div className="flex-1">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-200/70 text-accent-800 text-xs font-semibold mb-2">
                  QC Guide
                </span>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">
                  QC & Authenticity Checklist
                </h3>
                <p className="text-xs text-foreground-600">
                  Verify your purchases before shipping
                </p>
              </div>
              <div className="w-14 h-14 rounded-xl bg-accent-200 flex items-center justify-center flex-shrink-0 ml-4">
                <i className="ri-check-double-line text-accent-600 text-xl"></i>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}